import firebase from "@firebase/app";
import "@firebase/firestore";
import "@firebase/auth";
import "@firebase/storage";

var config = ''
if (process.env.NODE_ENV !== 'production') {
  //testing and development
  console.log('loaded ' + process.env.NODE_ENV)
  config = {
    apiKey: "AIzaSyA2KM6kCM-TPCHkhRzZRYUlYkiwN9EhUEo",
    authDomain: "testing-1941f.firebaseapp.com",
    databaseURL: "https://testing-1941f.firebaseio.com",
    projectId: "testing-1941f",
    storageBucket: "testing-1941f.appspot.com",
    messagingSenderId: "935583968559"
  };

} else {
  //production
  console.log('loaded ' + process.env.NODE_ENV)
  config = {
    apiKey: "AIzaSyDb7MzGohTf9D2x5C3G3fq2lTF4OgIh4jI",
    authDomain: "lemonbase-ee2df.firebaseapp.com",
    databaseURL: "https://lemonbase-ee2df.firebaseio.com",
    projectId: "lemonbase-ee2df",
    storageBucket: "lemonbase-ee2df.appspot.com",
    messagingSenderId: "587691969868"
  };
}

const app = firebase.initializeApp(config);
const db = firebase.firestore(app);
const auth = firebase.auth();
const storr = firebase.storage();
const fb = firebase
// const settings = {/* your settings... */ timestampsInSnapshots: true };
// db.settings(settings);

export {
  auth,
  db,
  storr,
  app,
  fb
};




// WEBPACK FOOTER //
// ./src/firebase/firebase.js